export enum CaseProperties {
	LAST_BO_DATE = 'lastBODate',
}